import type { SVGProps } from 'react';

const SvgAiSparkles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentcolor">
      <path d="M16.59 13.6c-3.75 0-6.18-2.42-6.18-6.18 0-.23-.18-.41-.41-.41s-.41.18-.41.41c0 3.75-2.42 6.18-6.18 6.18-.23 0-.41.18-.41.41s.18.41.41.41c3.75 0 6.18 2.42 6.18 6.18 0 .23.18.41.41.41s.41-.18.41-.41c0-3.75 2.42-6.18 6.18-6.18.23 0 .41-.18.41-.41s-.18-.41-.41-.41M20.76 6.77c-2.14 0-3.53-1.39-3.53-3.53 0-.13-.11-.24-.24-.24s-.24.11-.24.24c0 2.14-1.39 3.53-3.53 3.53-.13 0-.24.11-.24.24s.11.24.24.24c2.14 0 3.53 1.39 3.53 3.53 0 .13.11.24.24.24s.24-.11.24-.24c0-2.14 1.39-3.53 3.53-3.53.13 0 .24-.11.24-.24s-.11-.24-.24-.24" />
    </g>
  </svg>
);
export default SvgAiSparkles;
